export default class TransporterType {
    public transporterTypeId: number = 0;
    public name: string = '';
}
